/**
 * This is a TypeGen auto-generated file.
 * Any changes made to this file can be lost when this file is regenerated.
 */

export class LicenseClass {
    licenseClass_key: number;
    name: string;
    description: string;
}
